import { BodyText, Button, Stack } from "@knowtex-ai/components";
import { Trash, Upload } from "iconoir-react";
import type { ReactElement } from "react";

export interface RecorderUploadActionsProps {
  readyToUpload: boolean;
  isUploadDisabled: boolean;
  onUpload: () => void;
  onDelete: () => void;
}

export default function RecorderUploadActions({
  readyToUpload,
  isUploadDisabled,
  onUpload,
  onDelete,
}: RecorderUploadActionsProps): ReactElement | null {
  if (!readyToUpload) {
    return null;
  }

  return (
    <Stack gap={12} className="w-full">
      <Button
        id="submit_recording"
        type="button"
        variant="primary-alt"
        fullWidth
        icon={Upload}
        disabled={isUploadDisabled}
        onClick={onUpload}
      >
        Upload Audio
      </Button>
      <BodyText size="small" muted className="text-center">
        or
      </BodyText>
      <Button type="button" variant="secondary-danger" fullWidth icon={Trash} onClick={onDelete}>
        Delete Audio
      </Button>
    </Stack>
  );
}
